// extracted by mini-css-extract-plugin
export default {"questionTileBox":"questionTileBox-D4PYc","questionShortName":"questionShortName-bco1g"};